<template>
  <report-section 
    title="血氧统计累加统计" 
    class="blood-oxygen-stats-section"
  >
  
    <template v-slot:content>
      <div class="table-container">
        <el-table
          :data="tableData"
          border
          class="blood-oxygen-table"
          :show-header="true"
        >
          <el-table-column 
            prop="range" 
            label="范围（%）" 
            width="130"
            align="center"
          />
          <el-table-column 
            prop="duration" 
            label="时长" 
            width="225"
            align="center"
          />
          <el-table-column 
            prop="ratio" 
            label="总占比" 
            width="130"
            align="center"
          />
        </el-table>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";

export default {
  components: {
    ReportSection,
    KeyValueUnit,
  },

  props: {
    reportDetailModel: Object,
  },

  computed: {
    tableData() {
      return [
        {
          range: '<95',
          duration: this.reportDetailModel.bloodOxygenUnder95TimeStr,
          ratio: this.reportDetailModel.bloodOxygenUnder95RatioStr
        },
        {
          range: '<90',
          duration: this.reportDetailModel.bloodOxygenUnder90TimeStr,
          ratio: this.reportDetailModel.bloodOxygenUnder90RatioStr
        },
        {
          range: '<85',
          duration: this.reportDetailModel.bloodOxygenUnder85TimeStr,
          ratio: this.reportDetailModel.bloodOxygenUnder85RatioStr
        },
        {
          range: '<80',
          duration: this.reportDetailModel.bloodOxygenUnder80TimeStr,
          ratio: this.reportDetailModel.bloodOxygenUnder80RatioStr
        },
        {
          range: '<70',
          duration: this.reportDetailModel.bloodOxygenUnder70TimeStr,
          ratio: this.reportDetailModel.bloodOxygenUnder70RatioStr
        },
        {
          range: '<60',
          duration: this.reportDetailModel.bloodOxygenUnder60TimeStr,
          ratio: this.reportDetailModel.bloodOxygenUnder60RatioStr
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
// 专门针对血氧饱和度统计的标题样式
.blood-oxygen-stats-section {
  /deep/ .report-section-title-text {
    color: #000000 !important;
    font-size: 18px !important;
    font-weight: bold !important;
    margin-top: 20px !important;
  }
}

.table-container {
  height: auto;
  overflow: hidden;
}

// Element UI 表格样式
.blood-oxygen-table {
  border: 1px solid #ddd;
  border-radius: 0;
  width: 485px;
  
  /deep/ .el-table {
    border: none;
    width: 485px;
  }

  /deep/ .el-table__header-wrapper {
    .el-table__header {
      th {
        background-color: #f5f5f5;
        color: #333;
        font-size: 14px;
        font-weight: 600;
        border-bottom: 1px solid #ddd;
        border-right: 1px solid #ddd;
        height: 32px;
        padding: 4px 8px;
        text-align: center;
        
        &:last-child {
          border-right: none;
        }
      }
    }
  }

  /deep/ .el-table__body-wrapper {
    overflow: hidden;
    
    .el-table__body {
      td {
        color: #333;
        font-size: 14px;
        border-bottom: 1px solid #ddd;
        border-right: 1px solid #ddd;
        height: 32px;
        padding: 4px 8px;
        text-align: center;
        
        &:last-child {
          border-right: none;
        }
      }
      
      tr:last-child td {
        border-bottom: none;
      }
    }
  }

  /deep/ .el-table--border {
    border: 1px solid #ddd;
  }

  /deep/ .el-table--border::after {
    display: none;
  }

  /deep/ .el-table__body tr:hover > td {
    background-color: #fafafa;
  }

  /deep/ .el-table th.is-leaf {
    border-bottom: 1px solid #ddd;
  }

  /deep/ .el-table td {
    border-right: 1px solid #ddd;
  }

  /deep/ .el-table th {
    border-right: 1px solid #ddd;
  }

  // 去除表格底部留白
  /deep/ .el-table__body {
    margin-bottom: 0;
  }

  /deep/ .el-table__empty-block {
    display: none;
  }

  // 确保表格容器没有多余空间
  margin-bottom: 0;
  padding-bottom: 0;
}

// 确保打印时样式也生效
@media print {
  .blood-oxygen-stats-section {
    /deep/ .report-section-title-text {
      color: #000000 !important;
      font-size: 16px !important;
      font-weight: bold !important;
      margin-top: -20px !important;
    }
  }

  .blood-oxygen-table {
    /deep/ .el-table__header-wrapper {
      .el-table__header {
        th {
          background-color: #f5f5f5 !important;
          color: #333 !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          border-bottom: 1px solid #ddd !important;
          border-right: 1px solid #ddd !important;
        }
      }
    }

    /deep/ .el-table__body-wrapper {
      .el-table__body {
        td {
          color: #333 !important;
          font-size: 14px !important;
          border-bottom: 1px solid #ddd !important;
          border-right: 1px solid #ddd !important;
        }
      }
    }
  }
}
</style>